import styled from "styled-components";

import { theme } from "../../themes/themes";
export const ModalIDContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.neutral.white};
  border-radius: 8px;
  max-width: 464px;
  max-height: 500px;
  color: ${({ theme }) => theme.primary.purple};
`;
export const ModalHeader = styled.div`
  width: 100%;
  height: fit-content;
  label {
    margin: 20px;
    font-weight: 800;
    font-size: 20px;
    line-height: 27px;
  }
`;
export const ModalContent = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  padding: 20px;
  padding-top: 0px;
  label {
    margin: 10px 0;
    font-weight: 500;
    font-size: 18px;
    line-height: 25px;
  }
  input {
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.neutral.gray[2200]};
    padding: 10px;
    outline: none;
    margin: 10px 0;
  }
  input:disabled {
    background-color: ${({ theme }) => theme.neutral.gray[600]};
  }
`;
export const ModalAction = styled.div`
  width: 100%;
  height: fit-content;
  display: flex;
  justify-content: flex-end;
  padding: 0 20px;
`;
export const PrimaryButton = styled.button`
  width: 112px;
  height: 40px;
  background-color: ${({ theme }) => theme.primary.purpleMedium};
  border-radius: 4px;
  color: ${({ theme }) => theme.neutral.white};
  outline: none;
  border: none;
  margin: 0 10px;
`;
export const SecondayButton = styled.button`
  width: 112px;
  height: 40px;
  background-color: ${({ theme }) => theme.neutral.white};
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.primary.purpleMedium};
  color: ${({ theme }) => theme.primary.purpleMedium};
`;
export const InfoContainer = styled.div`
  background: ${({ theme }) => theme.neutral.gray[200]};
  border-radius: 4px;
  padding: 20px;
  .example-lbl {
    font-weight: 400;
    font-size: 13px;
    line-height: 16px;
    margin-left: 35px;
  }
`;

export const InfoHeading = styled.div`
  display: flex;
  label {
    margin: 0 10px;
    font-size: 13px;
    line-height: 16px;
    font-weight: 400;
  }
`;
export const SampleID = styled.div`
  background: ${({ theme }) => theme.neutral.gray[800]};
  border-radius: 8px;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  margin-left: 30px;
  label {
    font-weight: 600;
    font-size: 14px;
    line-height: 16px;
    margin: 10px 0;
  }
`;
export const ExampleList = styled.div`
  margin: 0 70px;
  display: flex;
  flex-direction: column;
  label {
    font-weight: 400;
    font-size: 13px;
    line-height: 24px;
    margin: 2px 0;
  }
`;
